<template>
  <v-card outlined v-if="dereferenceable || displayResult">
    <v-card-text v-if="dereferenceable">
      {{ $t("referenceInfo.description") }}
    </v-card-text>

    <template v-if="displayResult">
      <v-card-title>
        {{ $t("user.referenceInfo.result.title") }}
      </v-card-title>

      <v-card-text>
        <template v-if="audit">
          <strong v-if="model === 'minimal'">{{ requirement.referenceRequirement.result.result }}</strong>
          <strong v-if="model === 'step'">{{ requirement.referenceRequirement.result.points }}</strong>
        </template>

        <Markdown :value="requirement.referenceRequirement.result.description" />

        <v-chip color="red" v-if="!requirement.referenced">
          {{ $t("referenceInfo.notReferenced") }}
        </v-chip>
      </v-card-text>
    </template>

    <v-card-actions v-if="dereferenceable">
      <v-btn @click="dereference">
        {{ $t("referenceInfo.dereference") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DereferenceMinimalRequirementMutation from "@/gql/mutations/DereferenceMinimalRequirementMutation.gql";
import DereferenceStepModelRequirementMutation from "@/gql/mutations/DereferenceStepModelRequirementMutation.gql";

export default {
  props: {
    model: {
      type: String,
      default: "minimal",
    },

    fund: {
      type: Object,
      required: true,
    },

    requirement: {
      type: Object,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    displayResult() {
      return (
        this.requirement.referenceRequirement &&
        this.requirement.referenceRequirement.result &&
        this.requirement.referenceRequirement.fund.auditPeriod.year !== new Date().getFullYear()
      );
    },

    dereferenceable() {
      if (!this.requirement.referenced) return false;

      // auditors may dereference at any time
      if (this.audit) return true;

      // only in initial edit for minimal
      if (this.model === "minimal" && this.fund.minimalRequirementsState === "INITIAL_EDIT") return true;

      // only in edit for step
      if (this.model === "step" && this.fund.stepModelRequirementsState === "EDIT") return true;

      return false;
    },
  },

  methods: {
    dereference() {
      this.$apollo.mutate({
        mutation:
          this.model === "minimal" ? DereferenceMinimalRequirementMutation : DereferenceStepModelRequirementMutation,
        variables: {
          id: this.requirement.id,
        },
      });
    },
  },
};
</script>
